var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component"},[_vm._l((_vm.viewList),function(item,index){return [_vm._t("default",null,{"item":item,"index":index})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }